import { ReactNode } from 'react';
import { useLocation } from 'react-router';

import { AuthenticatedRoute } from '@/app/constant';
import { IntegrationSuggestionBanner } from '@/components/IntegrationSuggestionBanner';
import { CustomerManagementNavigation } from '@/components/legacy-ui/CustomerManagementNavigation';
import { Navigation } from '@/components/legacy-ui/Navigation';
import { TopNavBar } from '@/sections/topNavBar/TopNavBar';
import { useAuth } from '@/state/auth';
import { cn } from '@/utils/classname';

export function Body({ children }: { children?: ReactNode }) {
  const location = useLocation();
  const { isPraetorianUser, isDemoUser } = useAuth();
  const pathSegments = location.pathname.split('/');
  const routePath = pathSegments.slice(2).join('/'); // Get everything after userId

  const isCustomerManagementRoute = routePath.includes(
    AuthenticatedRoute.CUSTOMER_MANAGEMENT
  );

  return (
    <div className="relative flex size-full overflow-hidden">
      {isCustomerManagementRoute ? (
        isPraetorianUser && !isDemoUser ? (
          <CustomerManagementNavigation />
        ) : null
      ) : (
        <Navigation />
      )}
      <div className="flex size-full flex-col overflow-hidden">
        <TopNavBar />
        <div
          className={cn(
            'flex min-h-0 w-full flex-1 flex-col overflow-auto px-9 py-4'
          )}
        >
          {children}
        </div>
        <IntegrationSuggestionBanner />
      </div>
    </div>
  );
}
